import { memo } from 'react';
import { LoadingSpinner } from '../../../components/common/LoadingSpinner';

/**
 * Reusable submit button component with loading state
 */
export const SubmitButton = memo(
  ({ onClick, disabled, isLoading, loadingText = 'Loading...', children, className = '' }) => {
    return (
      <button
        type="submit"
        onClick={onClick}
        disabled={disabled || isLoading}
        className={`h-[56px] rounded-[10px] w-full flex items-center justify-center font-['Roboto:Medium',sans-serif] font-medium text-[16px] text-center text-white border-none cursor-pointer transition-colors ${
          disabled || isLoading ? 'bg-[#c3c3c5]' : 'bg-[#61b8e7] hover:bg-[#4fa5d5]'
        } disabled:cursor-not-allowed ${className}`}
        style={{ fontVariationSettings: "'wdth' 100" }}
      >
        {isLoading ? (
          <span className="flex items-center gap-2">
            <LoadingSpinner className="text-white" />
            {loadingText}
          </span>
        ) : (
          children
        )}
      </button>
    );
  },
);

SubmitButton.displayName = 'SubmitButton';
